import { useTranslation } from 'react-i18next';

import { Col, Row } from 'antd';
import { motion } from 'framer-motion';

import { EducationRecord } from 'types/commons';

import { DETAILS_PANEL_ROW_GUTTER, FALLBACK_VALUE } from 'constants/uiSettings';

import styles from '../EducationWorkExperience.module.scss';
import generateTimePeriodString from '../utils/generateDateString';

interface EducationItemProps {
  record: EducationRecord;
}

const EducationItem = ({ record }: EducationItemProps) => {
  const { t, i18n } = useTranslation();
  const timePeriodString = generateTimePeriodString({
    startDate: record.startDate,
    endDate: record.endDate,
    t,
    locale: i18n.language
  });

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
      className={styles.tableWrapper}
    >
      <Row className={styles.row} gutter={DETAILS_PANEL_ROW_GUTTER}>
        <Col span={24}>
          <div className={styles.title}>
            {record.institution || FALLBACK_VALUE}
          </div>
        </Col>
        <Col span={24}>{record.fieldOfStudy || FALLBACK_VALUE}</Col>
      </Row>

      <Row className={styles.row} gutter={DETAILS_PANEL_ROW_GUTTER}>
        <Col span={24}>
          <div className={styles.date}>{timePeriodString}</div>
        </Col>
      </Row>
    </motion.div>
  );
};

export default EducationItem;
